// Lodash
import { get } from 'lodash';
import { Actions as AuthActions, ActionTypes as AuthActionTypes } from '../../auth/store/actions';

// STORE ACTION AND STATE
import { Actions, ActionTypes } from './actions';
import { DashboardState, initialState } from './state';


export function reducer(state = initialState, action: Actions | AuthActions): DashboardState {
  switch (action.type) {
    // Task COMMON METHOD
    case ActionTypes.DASHBOARD_COMMON: {
      return state;
    }
    // Task Success COMMON METHOD
    case ActionTypes.DASHBOARD_COMMON_SUCCESS: {
      // commonly store and handle all Task modules
      return {
        ...state,
        [action.response.common.STATE]: get(action.response.data, action.response.common.API_RESPONSE),
      };
    }

    // CLEAR_REDUCER METHOD ON LOGOUT
    case AuthActionTypes.CLEAR_REDUCER: {
      return initialState;
    }

    // CLEAR_BUSINESS_REDUCER METHOD ON BUSINESS CHANGE
    case AuthActionTypes.CLEAR_BUSINESS_REDUCER: {
      return initialState;
    }
    // DEFAULT
    default:
      return state;
  }
}
